import PropTypes from 'prop-types'
import React from 'react'
import { Box, HStack, VStack } from '@chakra-ui/react'
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import Toast from '../../../../components/Toast/Toast'
import NumberBody from '../../../../components/Toast/ToastContents/NumberBody'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
export default function Resume({ nCargaPromedio, nPagosPendientes }) {
  return (
    <VStack alignItems="flex-start" spacing="30px">
      <Box>
        <UnderlineHeading text="Resumen" variant="h5" />
      </Box>
      <HStack>
        <Box w="50%">
          <Toast variant="gray">
            <NumberBody
              title="Carga promedio tarjeta"
              number={Number(nCargaPromedio || 0) || 0}
              icon={faCreditCard}
            />
          </Toast>
        </Box>
        <Box w="50%">
          <Toast variant="gray">
            <NumberBody
              title="Pagos pendientes"
              number={Number(nPagosPendientes || 0) || 0}
              icon={faCircleInfo}
            />
          </Toast>
        </Box>
      </HStack>
    </VStack>
  )
}

Resume.propTypes = {
  nCargaPromedio: PropTypes.number,
  nPagosPendientes: PropTypes.number,
}
